export default "__VITE_ASSET__DmImquIn__"